import { createFileRoute } from "@tanstack/react-router";
import { getSocialEmotionalAddPage } from "#/modules/sociaal-emotioneel/social-emotional.functions";
import { SociaalEmotioneelThemasReeksCrudPage } from "#/modules/sociaal-emotioneel/components/page.crud-sociaal-emotioneel";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/admin/social-emotional/add/",
)({
  loader: () => getSocialEmotionalAddPage(),
  component: AdminSocialEmotionalAddPage,
});

function AdminSocialEmotionalAddPage() {
  const loaderData = Route.useLoaderData();
  return (
    <SociaalEmotioneelThemasReeksCrudPage
      sociaalEmotioneelThemasReeks={loaderData.sociaalEmotioneelThemasReeks}
      isEditRoute={loaderData.isEditRoute}
      basePath="../social-emotional"
    />
  );
}
